import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import BaseModel from 'volta/models/base-model';
import collectionCommand from 'volta/utils/api/collection-command';
import resourceCommand from 'volta/utils/api/resource-command';

import type { IResourceName } from 'volta/models/base-model';
import type { ICustomFieldValue, TCustomFieldValues } from './types/custom-field-definition';

export const SourceResourceName: IResourceName = {
  singular: 'source',
  plural: 'sources',
  table: 'sources'
};

enum TSourceCommands {
  CreateSource = 'CreateSource',
  UpdateSource = 'UpdateSource'
}

export default class Source extends BaseModel {
  static createSource = collectionCommand<ICreateSourceCmd, Source, typeof Source>(
    TSourceCommands.CreateSource
  );

  updateSupplier = resourceCommand<IUpdateSourceCmd, Source>(TSourceCommands.UpdateSource);

  @attr('string')
  declare code: string;

  @attr('string')
  description?: string;

  @attr('string')
  createdBy?: string;

  @attr('string')
  updatedBy?: string;

  /**
   * Custom fields values
   */
  @attr({
    defaultValue: function () {
      return {};
    }
  })
  customFields!: TCustomFieldValues;

  [Type] = 'source' as const;
}

// -------------------
// Commands
// -------------------

export interface ICreateSourceCmd {
  code: string;
  description?: string;
  customFields?: ICustomFieldValue[];
}

export interface IUpdateSourceCmd {
  description?: string;
  customFields?: ICustomFieldValue[];
}
